import service from '@/utils/request'

/** 获取APP菜单列表 */
export function getAllAppMenu() {
  return service.get('/backend/system/app/menu')
}

/** 获取优品商城收益设置 */
export function getProfitSetting() {
  return service.get('/backend/system/setting/profit')
}

/** 获取快递公司列表 */
export function getExpressDeliveries() {
  return service.get(`/backend/system/delivery/list`)
}

/** 获取区域信息 */
export function getAllRegions() {
  return service.get(`/backend/system/region/all`)
}

export function getRegions(code) {
  return service.get(`/backend/system/region?code=${code}`)
}
